(function() {
  angular
    .module('kareo.ui.shared.directives.feature-area', [])
    .directive('featureArea', featureAreaDirective);

  function featureAreaDirective() {
    return {
      restrict: 'A',
      link,
    };
    function link(scope, element, attrs) {
      var show = false;
      var enabled = false;
      scope.$watch(attrs.featureArea, value => {
        if (value) {
          show = value.show;
          enabled = value.enabled;
        }
        element.toggleClass('ng-hide', !show);
        element.toggleClass('is-disabled', !enabled);
      });

      // prevent click
      // we should actually remove the href
      element.on('click', e => {
        if (!enabled) {
          e.preventDefault();
        }
      });
    }
  }
})();
